/**
 * Claim counts by approved claim and rejected claim with reason
 */
import get from "lodash.get"
import api from "../../../api/"

const header = [
	[
		"Template 11 - Claim counts by approved claim and rejected claim with reason"
	],
	["Number of claim counts", "", "Standard Plan", "Flexi Plan"]
]

/**
 * @param {*} claims
 * @param {*} status === "paid" || "rejected"
 * @param {*} plan  === "standard" || "flexi"
 */
const countClaim = (claims, isApproved, plan) => {
	if (isApproved) {
		return claims.filter(claim => {
			if (claim.status === "APPROVED") return claim
			if (claim.status === "Approved") return claim
		}).length
	} else
		return claims.filter(claim => {
			if (claim.status === "REJECTED") return claim
			if (claim.status === "Rejected") return claim
		}).length
}

/**
 * Helper that counts claim by total rejection code occurence
 */
const countClaimByRejectionCode = (list, code, plan) => {
	const output = list.filter(claim => {
		const codes =
			claim.rejectionCodes !== null
				? claim.rejectionCodes.map(item => item.code)
				: null
		if (codes === null) return
		else if (codes.includes(code)) return true
	}).length
	return output
}

const rows = payload => {
	const { list, settings } = payload
	const paidClaims = ["Paid claims", "", countClaim(list, true, "standard"), ""]

	const rejectedClaims = [
		"Rejected claims (paid amount = 0)",
		"",
		countClaim(list, false, "standard"),
		0
	]

	const rejectedClaimByReason = settings.map(item => {
		return [
			item.code.split("|"),
			item.name,
			countClaimByRejectionCode(list, item.code, "standard"),
			0 //TODO: Implement when we have asia VHIS flexi plans
		]
	})

	let output = [paidClaims, rejectedClaims, ...rejectedClaimByReason]

	return output
}

export default payload => {
	const workSheetData = [...header, ...rows(payload)]
	const workSheetColumns = [
		{ wpx: 50 },
		{ wpx: 500 },
		{ wpx: 200 },
		{ wpx: 200 }
	]
	const workSheetMerges = [
		{
			s: { r: 1, c: 0 },
			e: { r: 1, c: 1 }
		},
		{
			s: { r: 2, c: 0 },
			e: { r: 2, c: 1 }
		},
		{
			s: { r: 3, c: 0 },
			e: { r: 3, c: 1 }
		}
	]

	return { workSheetData, workSheetColumns, workSheetMerges }
}
